export default __webpack_public_path__ + "static/giftcard-b464a6b8aa16870971a34c4ee174dd10.jpg";